import React from 'react';
import styles from './Table.module.css';

export interface EmptyTableRowProps {
  message: string;
  colSpan?: number;
  className?: string;
}

const EmptyTableRow: React.FC<EmptyTableRowProps> = ({ 
  message, 
  colSpan = 1,
  className = '' 
}) => {
  return (
    <div 
      className={`${styles.emptyTableRow} ${className}`}
      style={{ gridColumn: `1 / -1` }}
    >
      <div className={styles.emptyTableMessage}>
        {message}
      </div>
    </div>
  );
};

export default EmptyTableRow;

